import { render, staticRenderFns } from "./house-item-deal.vue?vue&type=template&id=6b0ed698&scoped=true&"
import script from "./house-item-deal.vue?vue&type=script&lang=js&"
export * from "./house-item-deal.vue?vue&type=script&lang=js&"
import style0 from "./house-item-deal.vue?vue&type=style&index=0&id=6b0ed698&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6b0ed698",
  null
  
)

export default component.exports